{/* This file contains all globally shared constants */ }
import * as React from 'react'
import { CSSProperties } from 'react'
import * as Redux from 'redux'
import { Dispatch } from 'redux';
import * as ReactRedux from 'react-redux'
import * as ReactRouter from 'react-router'
import { browserHistory } from 'react-router'
import * as Request from './tgccRequest'
import { TgccApp } from './tgccmain';


////////////////////////  web.config global declarations //////////////////////
//  loaded in the default.aspx 
///////////////////////////////////////////////////////////////////////////////
declare var RouteBase: string;
declare var ImageRoot: string;
declare var AssetRoot: string;

// expecting releative route in teh following form:  ~/styles/file.css   or ~/images/pic.jpg   
const cleanRoot: string = RouteBase.replace(/\/$/i, '');
export const ResolveUrl = (url: string) => {
    return url.replace("~", cleanRoot)
}

//////////////////// GLOBAL STYLE RELATED ITEMS ////////////////////////
export var Styles = {
    darkTextColor: 'rgba(66,66,66,0.8)',
    boxShadow: '0 5px 10px #999999',
    singleBorder: '1px solid rgba(77,77,77,0.6)',
    cardBackground: 'rgba(255,255,255,0.7)',
    paleWhite: 'rgba(255,255,255,0.8)',
    grayHighlight: 'rgb(239,238,234)',
    buttonBackground: 'rgb(215,215,215)',
    inputBackground: 'rgb(239,238,234)',
    uploadImagePlaceholder: {
        PDF: ResolveUrl("~/images/uploadPdfPlaceHolder.png"),
        PSD: ResolveUrl("~/images/uploadPsdPlaceHolder.png"),
        AI: ResolveUrl("~/images/uploadAiPlaceHolder.png")
    },

    favoriteImageOverlaySrc: ResolveUrl("~/images/GCFavorite.png"),

    missingProductImageSrc: ResolveUrl("~/images/product_placeholder.png"),
    missingDesignImageSrc: ResolveUrl("~/images/design_placeholder.jpg"),
    missingProofImageSrc: ResolveUrl("~/images/missing_proof.png"),

    // the following definitions facilitate auto-completion in Code editor
    grayButtonLg: null,
    grayButton: null,
    grayBanner: null,
    closeButton: null,
    error: null,

    // divider styles
    dividerBreak: null,
    dividerStyle: null
}
const grayButtonLg: React.CSSProperties = {
    display: 'table',
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'CenturyGothic',
    fontSize: '28px',
    textTransform: 'uppercase',
    letterSpacing: '10px',
    color: 'white',
    background: 'rgb(103,186,175)',
    padding: '5px 40px',
    boxShadow: Styles.boxShadow,
    margin: '5px auto 10px',
    cursor: 'pointer',
}; Styles.grayButtonLg = grayButtonLg;
Styles.grayBanner = Object.assign({}, grayButtonLg, { cursor: 'default' });

const grayButton: CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#3A54B4',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0'
}; Styles.grayButton = grayButton;

const closeButton: CSSProperties = {
    position: 'absolute',
    right: '5px',
    top: '5px',
    content: 'x',
    color: '#fff',
    fontWeight: 300,
    fontFamily: 'Arial, sans-serif'
}; Styles.closeButton = closeButton;


const error: CSSProperties = {
    width: '100%',
    textAlign: 'center',
    color: 'red',
    fontWeight: 'bold',
    lineHeight: '20px',
    height: '20px',
    fontSize: '12px',
    fontStyle: 'italic'
}; Styles.error = error;


const working: CSSProperties = {
    position: 'relative',
    display: 'flex',
    alignSelf: 'center',
    padding: '0',
    margin: '0 auto',
    height: '45px'
};

const dividerStyle: CSSProperties = {
    width: '50%',
    border: 'none',
    height: '4px',
    borderRadius: '4px',
    background: Styles.grayHighlight,
    boxShadow: 'rgb(153, 153, 153) 0px 2px 4px'
}; Styles.dividerStyle = dividerStyle;

const dividerBreak: CSSProperties = {
    position: 'relative',
    width: '100%'
}; Styles.dividerBreak = dividerBreak;

let workingCentered = Object.assign({}, working, { margin: 'auto', alignSelf: 'center' });
export const workingGif = <img style={working} src={ResolveUrl("~/images/loading.gif")} />;

export const defaultCategory = 'New Designs';

export const corpCategory = 'Winter';

export const FoundingYear = 1994;

export const yearsInBusiness = () => new Date().getFullYear() - FoundingYear;

export const yearsInBusinessMilestone = () => Math.floor(yearsInBusiness() / 5) * 5;


//////////////// "Enumerations" for global use ///////////////////

export const FrontLocations = {
    None: 'None',
    FrontLeftorPocket: 'FrontLeftorPocket',
    SmallFront: 'SmallFront',
    MediumFront: 'MediumFront',
    FullFront: 'FullFront'
}
export const BackLocations = {
    None: 'None',
    SmallBack: 'SmallBack',
    MediumBack: 'MediumBack',
    FullBack: 'FullBack'
}
export enum EditStates {
    None,
    SelectProduct,
    SelectFrontLocation,
    SelectBackLocation,
    SelectDesign,
    SelectProductStyle,
    EditBackText,
    EditFrontText,
    UploadDesign
}

export const Routes = {
    Root: cleanRoot + '/',
    Home: cleanRoot + '/home',
    ProofEdit: cleanRoot + '/proofedit',
    EstimateApprove: (token: string) => `${cleanRoot}/approve-estimate?token=${token}`,
    EditEstimate: (token: string) => `${cleanRoot}/edit-estimate?token=${token}`,    
    DashBoard: cleanRoot + '/dashboard',
    About: cleanRoot + '/about',
    Process: cleanRoot + '/process',
    MadeInUsa: cleanRoot + '/madeinusa',
    Contact: cleanRoot + '/contact',
    CSR: cleanRoot + '/csr',
    Products: cleanRoot + '/products',
    ProductCategoryListView: cleanRoot + '/productCategories',
    CategoryView: (category: string) => { return cleanRoot + '/products/category/' + category },
    Register: cleanRoot + '/register',
    Login: cleanRoot + '/login',
    Campus: cleanRoot + '/campus',
    PapaJohns: cleanRoot + '/PapaJohns',
    PapaJohnsColorSelect: cleanRoot + '/PapaJohns/color-select',
    PapaJohnsDesignSelect: cleanRoot + '/PapaJohns/design-select',
    PapaJohnsSizeSelect: cleanRoot + '/PapaJohns/size-select',
    ViewPapaJohnsDesigns: cleanRoot + '/PapaJohns/view-designs',
    PapaJohnsRegister: cleanRoot + '/PapaJohns/register',
    PapaJohnsConfirmDetails: cleanRoot + '/PapaJohns/confirm-details',
    PapaJohnsShirtOfTheMonthClub: cleanRoot + '/PapaJohns/shirt-of-the-month',
    Ced: cleanRoot + '/ced',
    CampusDashboard: cleanRoot + '/campus/dashboard',
    CampusFAQ: cleanRoot + '/campus/FAQ',
    LegalPage: cleanRoot + '/legal',
    CampusShipping: cleanRoot + '/campus/shipping',
    CampusProofEdit: cleanRoot + '/campus/proofEdit',
    CampusProofEditCode: (code: string) => { return cleanRoot + '/campus/proofEdit?code=' + code },
    CampusLogin: cleanRoot + '/campus/login',
    CampusRegister: cleanRoot + '/campus/register',
    CampusProductListView: cleanRoot + '/campusProducts',
    CampusProductView: (brand: string, style: string, color: string) => { return cleanRoot + '/campusProducts/' + encodeURI(brand) + '/' + encodeURI(style) + '/' + encodeURI(color) },
    CampusCategoryView: (category: string) => { return cleanRoot + '/campusProducts/category/' + category },
    CampusProductCategoryListView: cleanRoot + '/campus/productCategories',
    CampusContact: cleanRoot + '/campus/contact',
    CampusHowItWorks: cleanRoot + '/campus/howitworks',
    CampusFeedback: cleanRoot + '/campus/feedback',
    CampusSearch: cleanRoot + '/campus/search',
    TShirtHero: cleanRoot + '/campus/TShirtHero',
    TShirtHeroVideo: cleanRoot + '/campus/TShirtHero/your-mission',
    TShirtHeroLearnMore: cleanRoot + '/campus/TShirtHero/learn-more',
    TShirtHeroTerms: cleanRoot + '/campus/TShirtHero/terms',
    CampusSearchKeyword: (keyword: string) => { return cleanRoot + '/campus/search?keyword=' + keyword },
    Schools: cleanRoot + '/campus/schools',
    OtherSchools: cleanRoot + '/campus/licenses',
    CampusAbout: cleanRoot + '/campus/about',
    MajorAccountsProductListView: cleanRoot + '/products',
    MajorAccountsFAQ: cleanRoot + '/FAQ',
    MajorAccountsDesigns: cleanRoot + '/designs',
    MajorAccountShipping: cleanRoot + '/shipping',
    DesignSearch: cleanRoot + '/keyword',
    DesignSearchView: (keyword: string) => { return cleanRoot + '/keyword?keyword=' + keyword },
    PaymentOptions: (id: string) => { return cleanRoot + '/campus/paymentOptions?proofId=' + id },
    MajorAccountsPaymentOptions: (id: string) => { return cleanRoot + '/paymentOptions?proofId=' + id },
    CampusProofView: (id: string) => { return cleanRoot + '/campus/proofview?proofId=' + id; },
    CampusDesignListView: cleanRoot + '/campus/designs',
    CampusProofRevise: (id: string) => { return cleanRoot + '/campus/proofrevise?proofId=' + id; },
    CampusProofRoster: (id: string) => { return cleanRoot + '/campus/proofroster?proofId=' + id; },
    CampusTbanker: (code: string) => { return cleanRoot + '/campus/tbanker?proofId=' + code; },
    CampusTvite: (code: string) => { return cleanRoot + '/campus/tvite?proofId=' + code; },
    CampusCollection: (theme: string) => { return cleanRoot + '/collection/collegiate/' + theme },
    RealCollection: (theme: string) => { return cleanRoot + '/realcampus/collection/realcampus/' + theme},
    RealCampusHome: cleanRoot + '/realcampus',
    RealCampusSchools: cleanRoot + '/realcampus/schools',
    RealCampusProductListView: cleanRoot + '/realcampus/products',
    RealCampusProductCategoryView: (category: string) => { return cleanRoot + '/realcampus/products/category/' + category },
    RealCampusProductView: (brand: string, style: string, color: string) => { return cleanRoot + '/realcampus/products/' + encodeURI(brand) + '/' + encodeURI(style) + '/' + encodeURI(color) },
    RealCampusDesignView: cleanRoot + '/realcampus/designs',
    RealCampusProofEdit: cleanRoot + '/realcampus/proofEdit',
    RealCampusRegister: cleanRoot + '/realcampus/register',
    RealCampusLogin: cleanRoot + '/realcampus/login',
    RealCampusDashboard: cleanRoot + '/realcampus/dashboard',
    RealCampusProofRevise: (id: string) => { return cleanRoot + '/realcampus/proofrevise?proofId=' + id },
    RealCampusPaymentOptions: (id: string) => { return cleanRoot + '/realcampus/paymentOptions?proofId=' + id },
    RealCampusProofRoster: (id: string) => { return cleanRoot + '/realcampus/proofroster?proofId=' + id; },
    RealCampusProofView: (id: string) => { return cleanRoot + '/realcampus/proofview?proofId=' + id },
    RealCampusTbanker: (code: string) => { return cleanRoot + '/realcampus/tbanker?proofId=' + code; },
    RealCampusTvite: (code: string) => { return cleanRoot + '/realcampus/tvite?proofId=' + code; },
    RealCampusSchoolRequest: cleanRoot + '/realcampus/request',
    MajorAccountsDesignListView: cleanRoot + '/designs',
    MajorAccountsKeyword: (keyword: string) => { return cleanRoot + '/designs/search?keyword=' + keyword },
    MajorAccountsDesignCat: (category: string) => { return cleanRoot + '/designs?designCat=' + category },
    ProofView: (id: string) => { return cleanRoot + '/proofview?proofId=' + id; },
    ProofRevise: (id: string) => { return cleanRoot + '/proofrevise?proofId=' + id; },
    ProofRoster: (id: string) => { return cleanRoot + '/proofroster?proofId=' + id; },
    Tbanker: (code: string) => { return cleanRoot + '/tbanker?proofId=' + code; },
    TVite: (code: string) => { return cleanRoot + '/tvite?proofId=' + code; },
    MajorAccountsProductView: (brand: string, style: string, color: string) => { return cleanRoot + '/products/' + encodeURI(brand) + '/' + encodeURI(style) + '/' + Request.encodeColor(color) },
    MajorAccountsBrandView: (brand: string) => { return cleanRoot + '/products/' + encodeURI(brand) },
    MajorAccountsCategory: (category: string) => { return cleanRoot + '/category/' + encodeURI(category) },
    MajorAccountsFeedBack: cleanRoot + '/feedback',
    Indigo: cleanRoot + '/indigo',
    IndigoRegister: cleanRoot + '/indigo/register',
    ConfirmEmail: cleanRoot + '/confirm-email',
    IndigoLogin: cleanRoot + '/indigo/login',
    IndigoDashboard: cleanRoot + '/indigo/dashboard',
    IndigoProofEdit: cleanRoot + '/indigo/proofedit',
    IndigoDesignListView: cleanRoot + '/indigo/designs',
    IndigoDesignListViewCat: (category: string) => { return cleanRoot + '/indigo/designs?designCat=' + encodeURI(category) },
    IndigoProductListView: cleanRoot + '/indigo/products',
    IndigoProductBrandView: (brand: string) => { return cleanRoot + '/indigo/products/' + encodeURI(brand) },
    IndigoProofView: (id: string) => { return cleanRoot + '/indigo/proofview?proofId=' + id; },
    IndigoProofRevise: (id: string) => { return cleanRoot + '/indigo/proofrevise?proofId=' + id },
    IndigoFAQ: cleanRoot + '/indigo/faq',
    IndigoContact: cleanRoot + '/indigo/contact',
    IndigoShipping: cleanRoot + '/indigo/shipping',
    IndigoAbout: cleanRoot + '/indigo/about',
    ChangeByCsr: cleanRoot + '/csr/change',
    MajorAccountsHelp: cleanRoot + '/helpthemhelpyou',
    K12Landing: cleanRoot + '/k12',
    CampusSchoolMerch: cleanRoot + '/campus/merch',
    Catalog: cleanRoot + '/catalog',
    CatalogDesignListView: cleanRoot + '/catDesigns',
    Webstore: cleanRoot + '/webstore',
    DtdSamplePrint: cleanRoot + '/csr/dtd-sample-print',
    DesignLicensedListView: (licenseId: number) => {
        var route = cleanRoot + '/campus/schools';
        if (licenseId)
            route += '?licenseId=' + licenseId;
        return route;
    }
}

export const StateAction = {
    LocalUserDataLoaded: 'LocalUserDataLoaded',
    SetEditState: 'SetEditState',
    UpdateProofDesignWithoutNav: "UpdateProofDesignWithoutNav",
    SetSelectedProductForDesign: 'SetSelectedProductForDesign',
    UpdateProofProduct: 'UpdateProofProduct',
    UpdateProofDesign: "UpdateProofDesign",
    UpdateIndigoProofProduct: "UpdateProofIndigoProduct",
    UpdateIndigoProofDesign: "UpdateProofIndigoDesign",
    UpdateCampusProofDesign: 'UpdateCampusProofDesign',
    UpdateRealCampusProofDesign: 'UpdateRealCampusProofDesign',
    UpdateRealCampusProofProduct: 'UpdateRealCampusProofProduct',
    UpdateCampusProofProduct: 'UpdateCampusProofProduct',
    UpdateProofNotes: 'UpdateProofNotes',
    UpdateProofDivision: 'UpdateProofDivision',
    UpdateProofSalesContact: 'UpdateProofSalesContact',
    ProofAndQuantitiesSubmitted: 'ProofAndQuantitiesSubmitted',
    SetActiveProof: 'SetActiveProof',
    UpdateProof: 'UpdateProof',
    SetCurrentDesignSelection: 'SetCurrentDesignSelection',
    UpdateSelectedDesignCode: 'UpdateSelectedDesignCode',
    UpdateEventName: 'UpdateEventName',
    UpdateInHandsDate: 'UpdateInHandsDate',
    UpdateCatalogDesigns: 'UpdateCatalogDesigns',
    FilterProductsByCategory: 'FilterProductsByCategory',
    FilterProductsBySearch: 'FilterProductsBySearch',
    FilterDesignsByCategory: 'FilterDesignsByCategory',
    FilterDesignsBySearch: 'FilterDesignsBySearch',
    FilterDesignsByLicense: 'FilterDesignsByLicense',
    ResetActiveProof: 'ResetActiveProof',
    SetFrontLocation: 'SetFrontLocation',
    SetBackLocation: 'SetBackLocation',
    SetFrontText: 'SetFrontText',
    SetBackText: 'SetBackText',
    DialogAction: 'DialogAction',
    Login: 'Login',
    Logout: 'Logout',
    SetUserInfo: 'SetUserInfo',
    ChangeProofFlags: 'ChangeProofFlags',
    MobileNavAction: 'MobileNavAction',
    ProofPopup: 'ProofPopup',
    CampusProofPopup: 'CampusProofPopup',
    RealCampusProofPopup: 'RealCampusProofPopup',
    Impersonate: 'Impersonate',
    ForwardLocation: 'ForwardLocation',
    SetPaymentType: 'SetPaymentType',
    ProofFromMerch: 'ProofFromMerch',
    DesignFromReal: 'DesignFromReal',
    Lead: 'Lead',
    SchoolRequest: 'SchoolRequest',
    DesignFromRealCampus: 'DesignFromRealCampus'
}

export const DialogAction = {
    UserLogin: 'UserLogin',
    ForgotPassword: 'ForgotPassword',
    CampusForgotPassword: 'CampusForgotPassword',
    ResetPassword: 'ResetPassword',
    ChangePassword: 'ChangePassword',
    RegisterUser: 'RegisterUser',
    ProofPopup: 'ProofPopup',
    CampusProofPopup: 'CampusProofPopup',
    RealCampusProofPopup: 'RealCampusProofPopup',
    MessagePopup: 'MessagePopup',
    Impersonate: 'Impersonate',
    FAQ: 'FAQ',
    ServiceContext: 'ServiceContext',
    CampusServiceContext: 'CampusServiceContext',
    MajorAccountsServiceContext: 'MajorAccountsServiceContext',
    EnLargeUpload: 'EnLargeUpload',
    ConfirmApproval: 'ConfirmApproval',
    ApprovalConfirmation: 'ApprovalConfirmation',
    RealCampusServiceContext: 'RealCampusServiceContext'
}

export class DialogActionType {
    action: string;
    payload: any;
}

/////////////////////// MODEL Definitions ////////////////////////
export class Proof {

    constructor() {
        this.text = { front: null, back: null, pocket: null, other: null };
        this.frontLocation = FrontLocations.None;
        this.backLocation = BackLocations.None;
    }

    proofId: string;
    product: Product;
    design: Design;
    status: string;
    statusDate: string;
    shipDate: string;
    orderDate: string;
    csr: string;
    text: {
        front: string,
        back: string,
        pocket: string,
        other: string
    };
    frontLocation: string;
    backLocation: string;
    notes: string;
    previousPurchases?: string; 
    timeSensitive: boolean;
    screenPrint: boolean;
    embroidery: boolean;
    eventName: string;
    orderSize: number;
    uploadedFiles: any;
    csrName: string;
    csrEmail: string;
    rosterCodes: string[];
    tracking: string;
    userEmail: string;
    inHandsDate: string;
    phone: string;
    smsAllowed: boolean;
    division: string;
    salescontact: string;
    requesttype:string;
    apparelItems?: {
        style: string;
        color: string;
        designs: {
            position: string;
            code: string;
            notes: string;
        }[];
    }[];

    designs?: {
        code: string;
        notes: string;
    }[];
}

export class DesignCategory {
    category: string;
    priority: number;
}

export class Design {
    id: string;
    keywords: string;
    image: string;
    thumbnail: string;
    displayIndex?: number;
    caption: string;
    licenseId?: number;
}

export class License {
    id: number;
    caption: string;
    license: string;
    licenseType: string;
    image: string;
    thumbnail: string;
    priority: number;
}

export class ProductCategory {
    category: string;
    id: number;
}
export class ProductBrand {
    brand: string;
    image: string;
    thumbnail: string;
    priority: number;
}

export class Product {
    brand: string;
    style: string;
    colorName: string;
    colorCode: string;
    description: string;
    features: string;
    specs: string;
    image: string;
    thumbnail: string;
    size: string;
    displayIndex: number;
    favorite: boolean;
    designation: string;
    designationOrdinal: number;
    colorCount: number;
    sizes?: string[];
}

export class SizesRec {

    XSmall: number;
    Small: number;
    Medium: number;
    Large: number;
    XLarge: number;
    XXL: number;
    XXXL: number;
    XXXXL: number;
    XXXXXL: number;
    XXXXXXL: number;
    Infant6: number;
    Infant12: number;
    Infant18: number;
    Infant24: number;
    Toddler2: number;
    Toddler3: number;
    Toddler4: number;
    Toddler5: number;
    Toddler6: number;
    Toddler7: number;
    YXSmall: number;
    YSmall: number;
    YMedium: number;
    YLarge: number;
    YXLarge: number;
    OneSize?: number;
}

export class TbankerInfo {
    code: string;
    proofId: string;
    price: number;
    status: string;
    date: string;
    event: string;
    organization?: string;
    school: string;
    chairName: string;
    chairEmail: string;
    shipType?: number;
    firstShipCost: number;
    additionalShipCost: number;
    activeAdultSizes: string[];
    activeYouthSizes: string[];
    isOneSize: boolean;
    hCowTag_IsSingleSizeItem: boolean;
    specialWebstore?: string;
    catalogUrl?: string;
}

export class TviteInfo extends TbankerInfo {
    youthSizes: boolean;
    isSingleSizeItem: boolean;
}
export class Feedback {
    name: string;
    email: string;
    message: string;
    timestamp: string;
}

export class ContactUs {
    contactName: string;
    name: string;
    timestamp: string;
    email: string;
    phone: string;
}

export class Lead {
    name: string;
    email: string;
    school: string;
    source: string;
    timestamp: string;
}

export class SchoolRequest {
    name: string;
    email: string;
    school: string;
    org: string;
    timestamp: string;
}

export const PaymentTypes = {
    Classic: "Classic",
    TVite: "TVite",
    TBanker: "TBanker",
    Omega: "Omega Fi"
}
export const MajorAccountsPaymentTypes = {
    Individual: "Individual Payment Link",
    TVite: "TVite",
    Traditional: "Traditional",
    Omega: "Omega Fi"
}
export const CampusPaymentTypes = {
    TBanker: "Individual Payment Link",
    TVite: "Individual Sign-Up Link",
    Classic: "Classic Order",
    Omega: "Omega Fi Order"
}

export const ErrorMessages = {
    ESTIMATE_ALREADY_PROCESSED: {
        heading: "Estimate Already Processed",
        message: "This estimate has already been approved or updated. If you need to make additional changes or reconsider your decision, please contact your Account Manager for further assistance."
    }
};

export class PaymentConfig {
    type: string;
    IsSpecialCase?: boolean;
    trFirstName?: string;
    trLastName?: string;
    trEmail?: string;
    omegaAcctNum?: number;
    classicPaymentType?: string;
    shirtSize?: string;
    quantity: string;
    XSmall?: string;
    Small?: string;
    Medium?: string;
    Large?: string;
    XLarge?: string;
    XXL?: string;
    XXXL?: string;
    XXXXL?: string;
    XXXXXL?: string;
    XXXXXXL?: string;
    YXSmall?: string;
    YSmall?: string;
    YMedium?: string;
    YLarge?: string;
    YXLarge?: string;
    Toddler2?: string;
    Toddler3?: string;
    Toddler4?: string;
    Toddler5?: string;
    Toddler6?: string;
    Toddler7?: string;
    Infant6?: string;
    Infant12?: string;
    Infant18?: string;
    Infant24?: string;
    OneSize?: string;
    address?: string;
    zipcode?: number;
    State?: string;
    city?: string;
    closeRosterDate?: string;
    shipmentType?: string;
}

export interface CurrentDesignSelection {
    apparelIndex: number;
    designIndex: number;
}

export class GlobalState {
    LoginData: LoginData;
    UserInfo: UserInfo;
    OrderHistory: Proof[];
    ActiveOrders: Proof[];
    ActiveProof: Proof;
    EditState: EditStates;
    Designs: Design[];
    DesignCategories: DesignCategory[];
    Products: Product[];
    ProductBrands: ProductBrand[];
    ProductCategories: string[];
    FilterProductsByCategory: ProductCategory;
    FilterProductsBySearch: string;
    FilterDesignsByCategory: string;
    FilterDesignsBySearch: string;
    FilterDesignsByLicense: number;
    DialogAction: DialogActionType;
    MobileNavAction: string;
    ProofPopup: Proof;
    ForwardLocation: string;
    PaymentConfig: PaymentConfig;
    didLead: boolean;
    currentDesignSelection?: CurrentDesignSelection;
    selectedDesignCode?: string;
}
export class LoginData {
    id: string;
    username: string;
    token: string;
    impersonate: string;
    expires: string;
}

export const LoginExpired = (loginData: LoginData) => {
    if (!loginData)
        return true;
    var expDate = new Date(loginData.expires);
    var nowDate = new Date();
    return expDate < nowDate;
}

export class UserInfo {
    firstName: string;
    lastName: string;
    address: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    schoolOrBusiness: string;
    organization: string;
    studentGroup: string;
    title: string;
    email: string;
    buyer: string;
    group: string;
    isAdmin: boolean;
    type: string;
    smsAllowed: boolean;
    isTShirtHeroRegistration: boolean;
    marketingOptIn: boolean;
    proofConfirmationEmailsEnabled: boolean = true; // Default to true for existing customers
}

export class BaseProps {
    state: GlobalState;
    router?: ReactRouter.InjectedRouter;
    dispatch?: Redux.Dispatch<any>;
    params?: any;
    location?: any;
}

export class sliderObject {
    sale: string;
    regPrice: string;
    prodName: string;
    prodStyle: string;
    onClick: () => void;
}

export const ShipmentTypes = {
    Bulk: 0,
    Individual: 1,
    Select: 2
}

export class MerchandisingTheme {
    id: number;
    theme: string;
    title: string;
    collection: string;
    image: string;
    bannerImage: string;
}
export class MerchBinding {
    merchandising: Merchandising;
    product: Product;
    design: Design;
    editRoute: string;
}
export class Merchandising {
    assetId: number;
    productBrand: string;
    productStyle: string;
    productColor: string;
    designWo: string;
    imageName: string;
    division: string;
    frontDesignPosition: string;
    frontDesignText: string;
    backDesignPosition: string;
    backDesignText: string;
    embroidery: boolean;
    priority: number;
    startDate: string;
    endDate: string;
    theme: string;
}

export class MerchandisingPayload {
    product: Product;
    design: Design;
    merchandising: Merchandising;
}

export class AddressVerifyModel {
    addr1: string;
    addr2: string;
    city: string;
    state: string;
    zip: string;
    zip4: string;
    error: string = "Address is not valid";
    xmlerror: string;
}

export class WebStore {
    title: string;
    description: string;
    closeDate: string;
    items: WebStoreItem[];
    shipType?: number;
    shipCostFirst?: number;
    shipCostAdditional?: number;
    contactName?: string;
    organization?: string;
    contactEmail?: string;
    address1?: string;
    address2?: string;
    addrCity?: string;
    addrState?: string;
    addrZip?: string;
    filterPrompt?: string;
    headerImg?: string;
    logo?: string;
}

export class WebStoreItem {
    id: number;
    webStoreId: number;
    priority: number;
    status: string;
    tBanker: TbankerInfo;
    productBrand: string;
    productColor: string;
    sizes: string[];
    filter?: string;
}

export class WebStoreCart {
    webStoreId: number;
    items: WebStoreCartItem[];
}

export class WebStoreCartItem {
    id: number;
    tBanker: TbankerInfo;
    quantity: number;
    size: string;
}

export class WebStoreCartItemModel {
    ItemId: number;
    TbCode: string;
    Price: number;
    Quantity: number;
    Size: string;
}

export class Checkout {
    FirstName: string;
    LastName: string;
    Email: string;
    Organization: string;
    IndividualShip: boolean;
    AddrLine1: string;
    AddrLine2: string;
    AddrCity: string;
    AddrState: string;
    AddrZip: string;
}

//////////////  Global Utility FUNCTIONS /////////////
export const LoginUser = (dispatch: (action: any) => void) => {
    dispatch({ type: StateAction.DialogAction, payload: { action: DialogAction.UserLogin } })
}

export const SaveUserData = (userInfo: UserInfo, loginData: LoginData) => {
    if (userInfo)
        localStorage.setItem("UserInfo", JSON.stringify(userInfo));
    if (loginData)
        localStorage.setItem("LoginData", JSON.stringify(loginData));
}

export const ClearUserData = () => {
    localStorage.removeItem('loginData');
    localStorage.clear();
}

export const LoadUserData = () => {
    var userInfo: UserInfo = null;
    var loginData: LoginData = null;

    var uData = localStorage.getItem("UserInfo");
    if (uData)
        userInfo = JSON.parse(uData);

    var lData = localStorage.getItem("LoginData");
    if (lData)
        loginData = JSON.parse(lData);

    // clear expired user data
    if (LoginExpired(loginData)) {
        ClearUserData();
        return { userInfo: null, loginData: null };
    }

    return { userInfo: userInfo, loginData: loginData };
}

export const UserIsAdmin = (state: GlobalState) => {
    if (!state.LoginData || LoginExpired(state.LoginData))
        return false;

    if (!state.UserInfo || !state.UserInfo.isAdmin)
        return false;

    return true;
}

export const LoadingElement = () => {
    return workingGif;
}

export const IsValidEmail = (email: string) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export const IsValidPhoneNumber = (phn: string) => {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
    return re.test(phn.replace(' ', ''));
}

export const handleDesignImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.src = Styles.missingDesignImageSrc;
}

export const promptForLogin = (dispatch: Dispatch<any>) => {
    dispatch({ type: StateAction.DialogAction, payload: { action: DialogAction.UserLogin } })
}

const endsWith = (str: string, suffix: string) => {
    return str.indexOf(suffix, str.length - suffix.length) >= 0;
}

export enum SortOrders {
    Default = "Select sort",
    AtoZ = "Product A to Z",
    ZtoA = "Product Z to A",
    LowToHigh = "Price Low to High",
    HighToLow = "Price High to Low"
}

export const successfulLogin = (dispatch: Dispatch<any>, loginData: LoginData, defaultRedirect: boolean = true, returnUrl: string | null = null) => {
    dispatch({ type: StateAction.Login, payload: loginData })
    dispatch({ type: StateAction.DialogAction, payload: null })
    Request.setAuthToken(loginData.token);
    Request.getUserInfo(loginData, (userInfo: UserInfo) => {
        SaveUserData(userInfo, loginData);
        dispatch({ type: StateAction.SetUserInfo, payload: userInfo });

        if (returnUrl) {
            console.log("Redirecting to returnUrl");
            window.location.href = returnUrl; // Redirect to returnUrl
        } else if (defaultRedirect && 
                   (endsWith(document.location.pathname, Routes.Register) || 
                    endsWith(document.location.pathname, Routes.Login))) {
            // Check if defaultRedirect is true and the current pathname is either Register or Login
            console.log("Default redirect is enabled, but not performing redirect due to settings.");
            window.location.href = Routes.Home; // Or whatever your default post-login route is
           
        }
    });
}

export const successfulCampusLogin = (dispatch: Dispatch<any>, loginData: LoginData, returnUrl?: string) => {
    dispatch({ type: StateAction.Login, payload: loginData });
    dispatch({ type: StateAction.DialogAction, payload: null });
    Request.setAuthToken(loginData.token);

    Request.getUserInfo(loginData, (userInfo: UserInfo) => {
        SaveUserData(userInfo, loginData);
        dispatch({ type: StateAction.SetUserInfo, payload: userInfo });

        if (returnUrl) {
            console.log("Redirecting to returnUrl");
            window.location.href = returnUrl;
        } else if (endsWith(document.location.pathname, Routes.CampusLogin) || endsWith(document.location.pathname, Routes.Root) || endsWith(document.location.pathname, Routes.CampusRegister)) {
            browserHistory.replace(Routes.CampusProofEdit);
        } else {
            browserHistory.replace(Routes.RealCampusProofEdit);
        }
    });
};

export const successfulIndigoLogin = (dispatch: Dispatch<any>, loginData: LoginData, returnUrl?: string) => {
    dispatch({ type: StateAction.Login, payload: loginData });
    dispatch({ type: StateAction.DialogAction, payload: null });
    Request.setAuthToken(loginData.token);
    Request.getUserInfo(loginData, (userInfo: UserInfo) => {
        SaveUserData(userInfo, loginData);
        dispatch({ type: StateAction.SetUserInfo, payload: userInfo });

        if (returnUrl) {
            console.log("Redirecting to returnUrl");
            window.location.href = returnUrl;
        } else if (endsWith(document.location.pathname, Routes.IndigoLogin) || endsWith(document.location.pathname, Routes.Root) || endsWith(document.location.pathname, Routes.IndigoRegister)) {
            browserHistory.replace(Routes.IndigoProofEdit);
        }
        // No else clause needed if there's no default route for Indigo
    });
};

export const successfulMajorAccountsLogin = (dispatch: Dispatch<any>, loginData: LoginData, returnUrl?: string) => {
    dispatch({ type: StateAction.Login, payload: loginData });
    dispatch({ type: StateAction.DialogAction, payload: null });
    Request.setAuthToken(loginData.token);
    Request.getUserInfo(loginData, (userInfo: UserInfo) => {
        SaveUserData(userInfo, loginData);
        dispatch({ type: StateAction.SetUserInfo, payload: userInfo });

        if (returnUrl) {
            console.log("Redirecting to returnUrl");
            window.location.href = returnUrl;
        } else if (endsWith(document.location.pathname, Routes.Login) || endsWith(document.location.pathname, Routes.Root) || endsWith(document.location.pathname, Routes.Register)) {
            browserHistory.replace(Routes.ProofEdit);
        }
        // Default redirect to ProofEdit for Major Accounts
    });
};


export const LogoutUser = (dispatch: Dispatch<any>, login: LoginData) => {
    if (login && login.impersonate) {
        successfulLogin(dispatch, Object.assign({}, login, { impersonate: null }));
    } else if (login) {
        Request.logoutUser(login, () => {
            browserHistory.replace(Routes.Home);
            dispatch({ type: StateAction.Logout, payload: null })
        });
    } else {
        dispatch({ type: StateAction.Logout, payload: null })
        browserHistory.replace(Routes.Home);
    }
}
export const LogoutCampusUser = (dispatch: Dispatch<any>, login: LoginData) => {
    if (login && login.impersonate) {
        successfulLogin(dispatch, Object.assign({}, login, { impersonate: null }));
    } else if (login) {
        Request.logoutUser(login, () => {
            browserHistory.replace(Routes.Campus);
            dispatch({ type: StateAction.Logout, payload: null })
        });
    } else {
        dispatch({ type: StateAction.Logout, payload: null })
        browserHistory.replace(Routes.Campus);
    }
}
export const LogoutRealCampusUser = (dispatch: Dispatch<any>, login: LoginData) => {
    if (login && login.impersonate) {
        successfulLogin(dispatch, Object.assign({}, login, { impersonate: null }));
    } else if (login) {
        Request.logoutUser(login, () => {
            browserHistory.replace(Routes.RealCampusHome);
            dispatch({ type: StateAction.Logout, payload: null })
        });
    } else {
        dispatch({ type: StateAction.Logout, payload: null })
        browserHistory.replace(Routes.RealCampusHome);
    }
}
export const LogoutIndigoUser = (dispatch: Dispatch<any>, login: LoginData) => {
    if (login && login.impersonate) {
        successfulLogin(dispatch, Object.assign({}, login, { impersonate: null }));
    } else if (login) {
        Request.logoutUser(login, () => {
            browserHistory.replace(Routes.Indigo);
            dispatch({ type: StateAction.Logout, payload: null })
        });
    } else {
        dispatch({ type: StateAction.Logout, payload: null })
        browserHistory.replace(Routes.Indigo);
    }
}

declare var ProofBase: string;
export const getProofPath = (proofId: string) => {
    if (proofId) {
        var clnBase = ProofBase.replace(/\/$/i, '');
        var date = new Date();
        var time = date.getTime();
        return clnBase + "/" + proofId.replace('WO', '') + ".jpg?t=" + time;
    }
    return Styles.missingProofImageSrc;
}


// Define your base URL somewhere in your configuration or environment variables

// export async function fetchImageUrlsFromBlob(proofId: string): Promise<string[]> {
//     // Remove 'WO' prefix if present
//     const cleanProofId = proofId.replace(/^WO/, '');
//     const url = `${cleanRoot}/proofs/images/${cleanProofId}`;
    
//     try {
//         const response = await fetch(url);
//         if (!response.ok) {
//             throw new Error(`HTTP error! Status: ${response.status}`);
//         }
//         const images = await response.json();
//         return images;
//     } catch (error) {
//         console.error('Error fetching proof images:', error);
//         return [];
//     }
// }


const MerchBase: string = 'images/merch';
export const getMerchImagePath = (merchImage: string) => {
    if (merchImage) {
        var clnBase = AssetRoot.replace(/\/$/i, '');
        return clnBase + "/merch/" + merchImage;
    }
    return Styles.missingProductImageSrc;
}

export const formatPhoneNumber = (s: string) => {
    var s2 = ("" + s).replace(/\D/g, '');
    var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return (!m) ? s : "(" + m[1] + ") " + m[2] + "-" + m[3];
}

export const getLogoPath = (imgPath: string) => {
    var filename = imgPath.substring(imgPath.lastIndexOf('/') + 1);
    return ImageRoot + 'licenses/' + filename;
}

export const getDesignPath = (imgPath: string) => {
    var filename = imgPath.substring(imgPath.lastIndexOf('/') + 1);
    return AssetRoot + 'designs/' + filename;
}

export const getBrandPath = (imgPath: string) => {
    // Check if imgPath is a full URL by looking for "http://" or "https://"
    if (imgPath.startsWith("http://") || imgPath.startsWith("https://")) {
        return imgPath; // Return the full URL as is
    }

    // For local paths, get the filename and construct the full path
    var filename = imgPath.substring(imgPath.lastIndexOf('/') + 1);
    return ImageRoot + 'images/brands/' + filename;
}

export const getProductPath = (imgPath: string) => {
    if (imgPath && (imgPath.startsWith("http://") || imgPath.startsWith("https://") || imgPath.startsWith("/"))) {
        return imgPath;
    }
    var filename = imgPath.substring(imgPath.lastIndexOf('/') + 1);
    return AssetRoot + 'products/' + filename;
}

export const getMerchLogo = (imgPath: string) => {
    var filename = imgPath.substring(imgPath.lastIndexOf('/') + 1)
    /*localhost to ImageRoot */
    return AssetRoot + 'merchlogos/' + filename;
}

declare var ProdCatIconBase: string;
export const getProdCatIcon = (imgPath: string) => {
    if (imgPath) {
        var clnBase = ProdCatIconBase.replace(/\/$/i, '');
        return clnBase + "/" + imgPath;
    }
    return Styles.missingProductImageSrc;
}

export const GetSizeLabel = (szName: string) => {
    switch (szName) {
        case 'Infant6': return '6mo';
        case 'Infant12': return '12mo';
        case 'Infant18': return '18mo';
        case 'Infant24': return '24mo';
        case 'Toddler2': return 'T2';
        case 'Toddler3': return 'T3';
        case 'Toddler4': return 'T4';
        case 'Toddler5': return 'T5';
        case 'Toddler6': return 'T6';
        case 'Toddler7': return 'T7';
        case 'OneSize': return 'One size';
        case 'XLarge': return 'XL';

        default: return szName;
    }
}